(() => {
  const selector = '[data-rec-complete-build]';

  const visibleProductForm = () => {
    const forms = [...document.querySelectorAll('#MainContent form[action*="/cart/add"]')];
    return forms.find((form) => {
      const rect = form.getBoundingClientRect();
      const style = window.getComputedStyle(form);
      return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
    }) || forms[0];
  };

  const mount = () => {
    const block = document.querySelector(selector);
    if (!block) return;

    const standard = document.querySelector('[data-rec-product-experience]');
    const passport = document.querySelector('[data-rec-passport-trigger]');
    const form = visibleProductForm();

    if (standard?.parentNode) {
      if (standard.nextElementSibling !== block) standard.insertAdjacentElement('afterend', block);
    } else if (passport?.parentNode) {
      if (passport.nextElementSibling !== block) passport.insertAdjacentElement('afterend', block);
    } else if (form?.parentNode && form.nextElementSibling !== block) {
      form.insertAdjacentElement('afterend', block);
    }

    block.hidden = false;
  };

  const boot = () => {
    mount();
    window.setTimeout(mount, 900);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', mount);
})();